module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/The-Stuarts-A-Bloody-Reign.4191f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/The-Stuarts-A-Bloody-Reign.jpg
// module id = uWy6
// module chunks = 0